import React from 'react';
import { useMessages } from '../../context/MessagesContext';

export function ContactCard({ contact, isSelected, onSelect }) {
  const { unreadCounts, resetUnread } = useMessages();
  const unreadCount = unreadCounts[contact.contactUuid] || 0;

  const getLastMessageTime = () => {
    if (!contact.lastMessageAt) return 'No messages';
    const date = new Date(contact.lastMessageAt);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (minutes < 1440) return `${Math.floor(minutes / 60)}h ago`;
    return date.toLocaleDateString();
  };

  const getInitials = () => {
    const name = contact.alias || contact.contactUuid;
    return name.substring(0, 2).toUpperCase();
  };

  const handleSelect = () => {
    onSelect();
    if (unreadCount > 0) {
      resetUnread(contact.contactUuid);
    }
  };

  return (
    <div
      onClick={handleSelect}
      className={`p-4 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition ${
        isSelected ? 'bg-blue-50' : ''
      } ${contact.isArchived ? 'opacity-60' : ''}`}
    >
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 relative">
          <span className="text-blue-600 font-semibold text-sm">
            {getInitials()}
          </span>
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start">
            <div className="font-semibold truncate">
              {contact.alias || contact.contactUuid.substring(0, 12)}
              {unreadCount > 0 && (
                <span className="ml-2 text-xs text-red-500 font-normal">
                  {unreadCount} new
                </span>
              )}
            </div>
            <div className="text-xs text-gray-500 ml-2 flex-shrink-0">
              {getLastMessageTime()}
            </div>
          </div>
          <div className="flex justify-between items-center mt-1">
            <div className="text-xs text-gray-500 truncate">
              {contact.lastMessagePreview || 'No messages yet'}
            </div>
            {contact.isArchived && (
              <span className="text-xs bg-gray-300 px-2 py-0.5 rounded ml-2 flex-shrink-0">
                Archived
              </span>
            )}
            <div className="text-xs bg-gray-200 px-2 py-0.5 rounded ml-2 flex-shrink-0">
              v{contact.keyVersion}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}